import React from 'react';
import dateFormat from 'dateformat';
import './CashpointsTransaction.less';
import {CashpointsTransactionDate} from "elements/cashpoints-transaction-date/CashpointsTransactionDate";
import {CashpointsTransactionAmount} from "elements/cashpoints-transaction-amount/CashpointsTransactionAmount";
import {CashPointTransactionTypes} from "new-constants/common.constants";

function getTransactionSign(transactionType) {
	switch (transactionType) {
		case CashPointTransactionTypes.TYPE_EARN:
			return '+';
			break;
		case CashPointTransactionTypes.TYPE_REFUND:
			return '+';
			break;
		case CashPointTransactionTypes.TYPE_SPEND_BY_WAITER:
			return '';
			break;
		case CashPointTransactionTypes.TYPE_SPEND_ON_ORDER:
			return '';
			break;
		case CashPointTransactionTypes.TYPE_DELETE_EXPIRED:
			return '';
			break;
		case CashPointTransactionTypes.TYPE_RECRUIT_A_FRIEND_REWARD:
			return '+';
			break;
		default:
			return '';
	}
}

export const CashpointsTransaction = ({date, amount, type}) => {
	const DateRegex = /^(\d{4})-(\d{1,2})-(\d{1,2})/;//2020-12-14 10:00:30.000000
	const regexResult = DateRegex.exec(date);
	let year, month, day;
	if (regexResult?.length >= 4) {
		year = regexResult[1];
		month = regexResult[2];
		day = regexResult[3];
	}

	return <div className="cashpoints-transaction">
		<div className="cashpoints-transaction__date">
			<CashpointsTransactionDate text={`${day}/${month}/${year}`}/>
		</div>
		<div className="cashpoints-transaction__amount">
			<CashpointsTransactionAmount text={`${getTransactionSign(type)}${amount}`}/>
		</div>
	</div>
}
